import { render, staticRenderFns } from "./VuePopper.vue?vue&type=template&id=1c9fed5c"
import script from "./VuePopper.vue?vue&type=script&lang=js"
export * from "./VuePopper.vue?vue&type=script&lang=js"
import style0 from "./VuePopper.vue?vue&type=style&index=0&id=1c9fed5c&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c9fed5c')) {
      api.createRecord('1c9fed5c', component.options)
    } else {
      api.reload('1c9fed5c', component.options)
    }
    module.hot.accept("./VuePopper.vue?vue&type=template&id=1c9fed5c", function () {
      api.rerender('1c9fed5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VuePopper.vue"
export default component.exports